import { mixin as clickAway } from 'vue-clickaway';
import { createNamespacedHelpers } from 'vuex';

import apiAuth from '@/api/auth.js';

import LoadingDots from '@/components/loading_dot/LoadingDot.vue';

import LayoutDefs from '@/store/layout/layout.d';

const { mapActions: mapLayoutActions } = createNamespacedHelpers('Layout');

export default {
  name: 'ModalChangePassword',
  components: { LoadingDots },
  mixins: [clickAway],

  data: function() {
    return {
      form: {
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: '',
        error: ''
      }
    };
  },

  methods: {
    ...mapLayoutActions({
      layoutStore_closeModal: LayoutDefs.actions.closeModal
    }),

    closeModal: function() {
      this.layoutStore_closeModal({ module: 'changePassword' });
    },

    // eslint-disable-next-line complexity
    handleOnUpdateClick: async function() {
      this.form.error = '';
      this.$loading.start('settings.changePassword');

      try {
        if (this.form.currentPassword === '' || this.form.newPassword === '') {
          this.form.error = 'Current, and new password are required.';
        } else if (this.form.newPassword != this.form.confirmNewPassword) {
          this.form.error = 'New password confirmation failed.';
        } else {
          await apiAuth.changePassword(this.form);
          this.layoutStore_closeModal({ module: 'changePassword' });
        }
      } catch (error) {
        this.form.error = 'Something went wrong when changing password.';
      }

      this.$loading.end('settings.changePassword');
    }
  }
};
